<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner-list">

        <!-- Título e botões de topo -->
        <div class="row mb-4 header-row">
            <div class="col-md-6">
                <div class="title-wrapper">
                    <div>
                        <h1 class="title-default">Natureza de Operação</h1>
                        <p class="welcome-message">
                            <button mat-icon-button (click)="voltar()">
                                <mat-icon>arrow_back</mat-icon>
                            </button>
                            Gerenciamento das naturezas de operação e fórmulas do motor fiscal.
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-md-6 header-actions">
                <button
                    mat-stroked-button
                    class="btn-secondary"
                    [matMenuTriggerFor]="opcoesMenu">
                    @if (selection?.hasValue()) {
                        <span>Ações ({{ selection.selected.length }})</span>
                    } @else {
                        <span>Ações</span>
                    }
                    <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
                </button>
                <mat-menu #opcoesMenu="matMenu">
                    <button
                        mat-menu-item
                        (click)="excluirSelecionados()"
                        [disabled]="!podeExcluirSelecionados()"
                        [matTooltip]="getExcluirTooltip()">
                        <mat-icon class="material-symbols-outlined">delete</mat-icon>
                        <span>Excluir selecionados</span>
                    </button>
                </mat-menu>                
                <button mat-stroked-button class="btn-secondary" (click)="abrirTabelaDifal()">
                    <mat-icon class="material-symbols-outlined">balance</mat-icon>
                    Tabela DIFAL
                </button>                
                <button mat-stroked-button class="btn-secondary" (click)="abrirRegrasTributarias()">
                    <mat-icon class="material-symbols-outlined">gavel</mat-icon>
                    Regras Tributárias
                </button>
                <button mat-flat-button class="btn-primary" (click)="novaNatureza()">
                    <mat-icon class="material-symbols-outlined">add</mat-icon>
                    Nova Natureza
                </button>
            </div>
        </div>

        <!-- Abas -->
        <mat-tab-group class="main-tabs" appTabsScroll [mat-stretch-tabs]="false" [disablePagination]="true"
            (selectedTabChange)="$event.index === 1 ? onTabFormulasAtivada() : null">

            <!-- ABA 1: Naturezas -->
            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon class="material-symbols-outlined tab-icon">list_alt</mat-icon>
                    <span class="tab-label-text">Naturezas</span>
                </ng-template>
                <app-naturezas-lista></app-naturezas-lista>
            </mat-tab>

            <!-- ABA 2: Fórmulas -->
            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon class="material-symbols-outlined tab-icon">function</mat-icon>
                    <span class="tab-label-text">Fórmulas Padrão</span>
                </ng-template>
                <app-formulas-tab
                    [grupos]="_gruposFormulas"
                    [isLoading]="_isLoadingFormulas"
                    (modeloEmpresaSelecionado)="alterarModeloEmpresa($event)">
                </app-formulas-tab>
            </mat-tab>

        </mat-tab-group>

    </div>
</div>
